<template>
    <span>{{ formattedAmount }}</span>
  </template>
  
  <script lang="ts">
  import { Vue, Component, Prop, toNative } from 'vue-facing-decorator'
  
  @Component
  class CurrencyFormatter extends Vue {
    @Prop({ type: [Number, String], required: true })
    amount!: number | string
  
    @Prop({ type: String, default: 'USD' })
    currency!: string
  
    @Prop({ type: String, default: 'en-US' })
    locale!: string
  
    @Prop({ type: String, default: 'symbol' })
    currencyDisplay!: 'symbol' | 'code' | 'name'
  
    get formattedAmount(): string {
      const value = Number(this.amount)
      if (isNaN(value)) return String(this.amount)
  
      return new Intl.NumberFormat(this.locale, {
        style: 'currency',
        currency: this.currency,
        currencyDisplay: this.currencyDisplay,
      }).format(value)
    }
  }
    export default toNative(CurrencyFormatter)
  </script>
  